// extracted by mini-css-extract-plugin
module.exports = {"rowContainer":"VerseRangesList_rowContainer__TTjYL"};